import { Typography } from '@mui/material';
import React, {createContext, useContext, useEffect, useRef, useState} from 'react';
import {useMessageContextManager} from '../components/MessageOverlay/MessageOverlay';

export const NetworkStatusContext = createContext(null);

const NetworkStatusProvider = ({children}) => {
	const {showMessageOverlay} = useMessageContextManager();

	const [offline, setOffline] = useState(false);
  const closeOverlay = useRef(null);

	const handleOnline = () => {
		setOffline(false);
	};

	const handleOffline = () => {
		setOffline(true);
	};

	useEffect(() => {
		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	useEffect(() => {
		if (offline) {
			closeOverlay.current = showMessageOverlay({
				contextText: 'Network Issue',
				info: ' ',
				render: () => (
					<>
						<Typography variant='h5' fontWeight={400}>Please check your network connection.</Typography>
						<Typography variant='h5' fontWeight={600}>If issue persists, please contact your local network team.</Typography>
					</>
				),
				error: true,
			});
		} else {
      if (closeOverlay.current)
        closeOverlay.current();
    }
	}, [offline]);

	return (
		<NetworkStatusContext.Provider
			value={{
				offline,
			}}
		>
			{children}
		</NetworkStatusContext.Provider>
	);
};

export default NetworkStatusProvider;

export const useNetworkStatus = () => useContext(NetworkStatusContext);
